export default __webpack_public_path__ + "static/media/disable-light.1534ffe4.svg";